import { useRouter } from 'next/router';
import * as React from 'react';

// eslint-disable-next-line react/display-name
const withQueryParams = (Component: React.ComponentType<any>) => {
  const withQueryParamsComponent = (props: JSX.IntrinsicAttributes) => {
    const router = useRouter();
    if (router.isReady || !!router.query) {
      return (
        <>
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          <Component {...props} />
        </>
      );
    }
    return (
      null
    );
  };
  withQueryParamsComponent.displayName = `withQueryParamsComponent(${getDisplayName(Component)})`;
  return withQueryParamsComponent;
};

function getDisplayName(WrappedComponent: React.ComponentType<any>) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

export default withQueryParams;
